
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.037 1.15h3.613v2.1H.1v-2.1h3.613L4.787.125h5.176l1.074 1.025zM3.225 6.375v10.4h8.3v-10.4h-8.3zm-2.1 10.4v-12.5h12.5v12.5c0 .554-.212 1.042-.635 1.465-.423.423-.911.635-1.465.635h-8.3c-.554 0-1.042-.212-1.465-.635-.423-.423-.635-.911-.635-1.465z","fill":"#172542"}})])
          )
        }
      }
    